import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronLeft, Mail, Target } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card } from '@/components/ui/card';
import { AdminLayout } from '@/components/layout/AdminLayout';

export function AdminCampaignCreateInfo() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    subject: '',
    previewText: '',
    senderName: '',
    replyTo: ''
  });

  const handleNext = () => {
    navigate('/admin/campaigns/new/targeting');
  };

  return (
    <AdminLayout>
      <div className="p-8 max-w-2xl mx-auto">
        <Link to="/admin" className="inline-flex items-center text-muted-foreground hover:text-white mb-6">
          <ChevronLeft className="w-5 h-5 mr-1" />
          Back to Dashboard
        </Link>

        <h1 className="text-3xl font-bold text-white mb-2">Create Campaign</h1>
        <p className="text-muted-foreground mb-8">Set up your email campaign</p>

        {/* Step Indicator */}
        <div className="flex items-center gap-4 mb-8">
          <div className="flex items-center gap-2 text-primary">
            <div className="w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-semibold">1</div>
            <span className="text-sm font-medium">Campaign Info</span>
          </div>
          <div className="flex-1 h-px bg-border max-w-[60px]" />
          <div className="flex items-center gap-2 text-muted-foreground">
            <div className="w-8 h-8 rounded-full bg-secondary flex items-center justify-center text-sm font-semibold">2</div>
            <span className="text-sm">Targeting</span>
          </div>
        </div>

        <Card className="bg-card border-border p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 rounded-lg bg-primary/20 flex items-center justify-center">
              <Mail className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-white">Campaign Details</h2>
              <p className="text-sm text-muted-foreground">Basic information about your campaign</p>
            </div>
          </div>

          <div className="space-y-6">
            <div>
              <label className="text-sm text-muted-foreground mb-2 block">Campaign Name</label>
              <Input 
                placeholder="e.g., Early Bird Sale Announcement"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                className="bg-secondary border-border"
              />
              <p className="text-xs text-muted-foreground mt-1">Internal name for your reference</p>
            </div>

            <div>
              <label className="text-sm text-muted-foreground mb-2 block">Email Subject Line</label>
              <Input 
                placeholder="e.g., 🎉 Don't miss our exclusive early bird offer!"
                value={formData.subject}
                onChange={(e) => setFormData({...formData, subject: e.target.value})}
                className="bg-secondary border-border"
              />
            </div>

            <div>
              <label className="text-sm text-muted-foreground mb-2 block">Preview Text</label>
              <Input 
                placeholder="Text that appears after the subject line in inbox"
                value={formData.previewText}
                onChange={(e) => setFormData({...formData, previewText: e.target.value})}
                className="bg-secondary border-border"
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-sm text-muted-foreground mb-2 block">Sender Name</label>
                <Input 
                  placeholder="e.g., EXIT88 Events"
                  value={formData.senderName}
                  onChange={(e) => setFormData({...formData, senderName: e.target.value})}
                  className="bg-secondary border-border"
                />
              </div>
              <div>
                <label className="text-sm text-muted-foreground mb-2 block">Reply-To Email</label>
                <Input 
                  type="email"
                  placeholder="e.g., hello@exit88.live"
                  value={formData.replyTo}
                  onChange={(e) => setFormData({...formData, replyTo: e.target.value})}
                  className="bg-secondary border-border"
                />
              </div>
            </div>

            <Button 
              className="w-full bg-primary text-primary-foreground hover:bg-primary/90 h-12"
              onClick={handleNext}
            >
              Continue to Targeting
            </Button>
          </div>
        </Card>
      </div>
    </AdminLayout>
  );
}

export default AdminCampaignCreateInfo;
